import { CommonModule } from '@angular/common';
import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TextFieldComponent } from '../../../shared/components/controls/text-field/text-field.component';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { ValidationMessageComponent } from '../../../shared/components/validation-message/validation-message.component';
import { FileComponent } from '../../../shared/components/controls/file/file.component';
import { SkeletonLoaderComponent } from "../../../shared/components/skeleton-loader/skeleton-loader.component";
import { DocumentServiceType, FieldValue } from '../../../shared/constants/services.enum';
import { DocumentItem, FolderResponse } from '../../../shared/models/documents-response.model';
import { TranslateModule } from '@ngx-translate/core';
import { GuestTokenService } from '../../../core/services/guest-token.service';
import { SharedService } from '../../../shared/services/shared.service';
import { CaseService } from '../../../shared/services/case.service';
import { Utils } from '../../../Utils/utils';
import { ServiceProgressComponent } from "../../../shared/components/service-progress/service-progress.component";
import { environment } from '../../../../environments/environment';
import { SrStatus } from '../../../shared/constants/status.enum';
import { OptionFieldComponent } from '../../../shared/components/controls/option-field/option-field.component';

type MessageEntry = {
  id?: string;
  author: string;
  timestamp: string;
  body: string;
  readFlag?: string;
  complainantReadFlag?: string;
  respondentReadFlag?: string;
};

@Component({
  selector: 'app-case-detail',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TextFieldComponent, ButtonComponent, ValidationMessageComponent,
    FileComponent, SkeletonLoaderComponent, TranslateModule, ServiceProgressComponent, OptionFieldComponent],
  templateUrl: './case-detail.component.html',
  styleUrl: './case-detail.component.scss'
})
export class CaseDetailComponent implements OnInit {
  @ViewChild('notesSection') notesSection?: ElementRef<HTMLElement>;
  pageView: 'after-login' | 'guest' = 'guest';
  //URL with queryString = mediation-case-detail?ref=695307&case=90/2025
  documentServiceType = DocumentServiceType;
  caseMeta = {
    srNumber: '',
    caseNo: '',
    caseUserType: '',
    createdDate: '',
    complaint: '',
    respondent: '',
    personInCharge: '',
    disputeAmount: '',
    mediator: '',
    mediatorEmail: '',
    mediatorContact: '',
    mediatorComment: ''
  };

  responseForm: FormGroup;
  attachments: any[] = [];

  messageHistory: MessageEntry[] = [];
  responseSubmitted = false;
  srFolder: any;
  systemDocuments: Array<{ doc: DocumentItem; folder: FolderResponse }> = [];
  selectedDocumentType: string = '';
  loadingDoc: boolean = false;
  lang: string = "en";
  caseDetailLoading: boolean = false;
  noteSubmitting: boolean = false;
  referenceNumber: string = "";
  caseNumber: string = "";
  loginName: string = "";
  showAllMessages: boolean = false;
  markingAsRead: boolean = false;
  complaintName: string = "";
  showActions: boolean = true;
  private isEncryptedQuery = false;
  constructor(
    private fb: FormBuilder,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private caseService: CaseService,
    private guestTokenService: GuestTokenService
  ) {
    this.route.data.subscribe(data => {
      this.pageView = data['type'];
    });
    if (!this.route.snapshot.queryParams['ref'] && !this.route.snapshot.queryParams['case']) {
      this.goBack();
    }
    const refParam = this.route.snapshot.queryParams['ref'];
    const caseParm = this.route.snapshot.queryParams['case'];
    if (caseParm && this.pageView == 'guest') {
      this.isEncryptedQuery = true;
      this.caseNumber = encodeURIComponent(caseParm)
      this.referenceNumber = encodeURIComponent(refParam)
      this.caseMeta.caseNo = this.caseNumber;
    } else {
      this.caseNumber = caseParm
      this.referenceNumber = refParam
    }
    this.loginName = this.sharedService.getUserProfile()?.['Login Name'] ?? '';

    this.responseForm = this.fb.group({
      response: ['', [Validators.required, Validators.maxLength(4000)]],
      documentType: [null]
    });
  }
  caseRows = [
    { label: 'CASE.SR', value: () => this.caseMeta.srNumber },
    { label: 'CASE.COMPLAINT_NUMBER', value: () => this.caseMeta.caseNo },
    { label: 'CASE.CREATED_DATE', value: () => this.caseMeta.createdDate },
    { label: 'CASE.COMPLAINTS', value: () => this.caseMeta.complaint },
    { label: 'CASE.RESPONDENT', value: () => this.caseMeta.respondent },
    { label: 'CASE.PERSON_IN_CHARGE', value: () => this.caseMeta.personInCharge },
    { label: 'CASE.DISPUTE_AMOUNT', value: () => this.caseMeta.disputeAmount },
    { label: 'CASE.MEDIATOR_COMMENT', value: () => this.caseMeta.mediatorComment },
    { label: 'CASE.MEDIATOR', value: () => this.caseMeta.mediator },
    { label: 'CASE.MEDIATOR_EMAIL', value: () => this.caseMeta.mediatorEmail },
    { label: 'CASE.MEDIATOR_CONTACT', value: () => this.caseMeta.mediatorContact }
  ];

  ngOnInit(): void {
    this.initializeCaseDetail();
  }

  gotoNotesSection(): void {
    if (this.notesSection?.nativeElement) {
      this.notesSection.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    this.expandMessages();
    //this.markUnreadNotesAsRead();
  }
  handelFileEvent(f: any, a: any) {

  }
  get isRespondant() {
    let respondent = true;
    if (this.caseMeta.caseUserType?.toUpperCase() === FieldValue.User_COMPLAINANT_EN ||
      this.caseMeta.caseUserType === FieldValue.User_COMPLAINANT_AR) {
      respondent = false;
    } else {
      respondent = true;
    }
    return respondent;
  }

  private get isComplainantUserType(): boolean {
    return this.caseMeta.caseUserType?.toUpperCase() === FieldValue.User_COMPLAINANT_EN ||
      this.caseMeta.caseUserType === FieldValue.User_COMPLAINANT_AR;
  }
  // This method is used to open folder
  documentUserType = "RESPONDENT";
  documentTypeOptions: any = [];
  openFolder() {
    this.loadingDoc = true;
    let isLabels = false;

    if (this.caseMeta.caseUserType?.toUpperCase() === FieldValue.User_COMPLAINANT_EN ||
      this.caseMeta.caseUserType === FieldValue.User_COMPLAINANT_AR) {
      this.documentUserType = "COMPLAINANT";
    } else {
      this.documentUserType = "RESPONDENT";
    }
    this.sharedService.getDocuments(this.caseMeta.srNumber, DocumentServiceType.MED_CASE, isLabels, { userType: this.documentUserType, caseNo: this.plainCaseNumber })
      .subscribe({
        next: (response: any) => {
          if (response.success) {
            this.loadingDoc = false;
            this.srFolder = response.data ? response.data : response;

            this.systemDocuments = this.buildSystemDocuments(this.srFolder);

            // documents list for dropdown
            const allowed = this.srFolder?.allowedDocumentTypes ?? [];
            this.documentTypeOptions = allowed.map((dt: any) => ({
              label: this.lang === 'en' ? dt.nameEn : (dt.nameAr || dt.nameEn),
              value: dt.nameEn
            }));

          } else {
            this.loadingDoc = false;
            this.sharedService.toastMessage("error", response.message, 'error');
          }
        },
        error: () => {
          this.loadingDoc = false;
        }
      });
  }

  // This method is used to get case detail
  technicalErrorMsg: boolean = false;
  private fetchCaseDetail() {
    if (!this.caseNumber) {
      return;
    }

    this.caseDetailLoading = true;
    let req = {
      serialNumber: this.getRequestSerialNumber(),
      referenceNumber: this.getRequestReferenceNumber(),
      loginName: this.loginName,
      dcMethod: "QUERY",
      dcEncryptedValue: this.isEncryptedQuery ? "Y" : ""
    }
    this.caseService
      .getCaseDetail(req)
      .subscribe({
        next: (response) => {
          this.caseDetailLoading = false;
          if (response['Error Code'] == null && !response['Error Message']) {
            this.mapCaseDetailResponse(response);
          } else {
            this.technicalErrorMsg = true;
          }
        },
        error: () => {
          this.caseDetailLoading = false;
        },
      });
  }

  //This method is used to get guest token
  private initializeCaseDetail(): void {
    if (this.sharedService.getUser()) {
      this.fetchCaseDetail();
      return;
    }

    this.caseDetailLoading = true;
    this.guestTokenService.ensureGuestToken().subscribe({
      next: () => {
        this.loginName = environment.guestUser;
        this.fetchCaseDetail();
      },
      error: () => {
        this.caseDetailLoading = false;
        this.sharedService.toastMessage('ERROR', 'SOMETHING_WENT_WRONG', 'error');
      }
    });
  }
  plainCaseNumber: string = "";
  private mapCaseDetailResponse(response: any) {
    const caseList = Utils.checkIsArray(response.SiebelMessage['DC Community Portal Mediation Cases']);
    const mediationCase = caseList ? caseList[0] : "";
    if (!mediationCase) {
      return;
    }

    if (mediationCase['DC Status'] == SrStatus.Closed) {
      this.showActions = false;
      this.responseForm.disable(); // disables all fields in the form
    }

    this.complaintName = this.lang == 'ar' ? mediationCase['DC SR Complainant ARA Name'] : mediationCase['DC SR Complainant ENU Name'] || "";
    this.plainCaseNumber = mediationCase?.['Serial Number'];
    this.caseMeta = {
      // SR / Case identifiers
      srNumber: mediationCase?.['DC SR Num'] || '',
      caseNo: mediationCase?.['Serial Number'] || '',
      caseUserType: response?.DCCaseUserType || '',

      // Core case info
      createdDate: mediationCase?.['Created'] || '',
      complaint: mediationCase?.['DC SR Complainant ENU Name'] || mediationCase?.['DC SR Complainant ARA Name'] || '',

      // Parties
      respondent:
        mediationCase?.['DC SR Respondant Name ENU'] ||
        mediationCase?.['DC SR Respondant Name ARA'] ||
        '',
      personInCharge:
        mediationCase?.['DC SR Complainant Person In Charge'] ||
        '',
      // Financials
      disputeAmount: mediationCase?.['DC SR Dispute Amount']
        ? `${mediationCase['DC SR Dispute Amount']}`
        : '',

      // Mediator info
      mediator: mediationCase?.['Case Owner Full Name'] || '',
      mediatorEmail: mediationCase?.['Case Owner Email Id'] || '',
      mediatorContact:
        mediationCase?.['DC Case Owner Ext Calc'] ||
        mediationCase?.['DC Case Owner Ext Calc'] ||
        '',
      mediatorComment: mediationCase?.['DC SR Mediator Comment'] || ''
    };


    const notes = this.normalizeCaseNotes(mediationCase);
    if (notes.length) {
      this.messageHistory = notes;
      this.showAllMessages = false;
    }

    this.openFolder();
  }

  // This method is used to normalize case notes from the response
  private normalizeCaseNotes(mediationCase: any): MessageEntry[] {
    const rawNotes =
      mediationCase?.['DC Community Portal Mediation Case Notes'];
    if (!rawNotes) {
      return [];
    }
    const notesArray = Utils.checkIsArray(rawNotes);
    return notesArray
      .filter((note: any) => note?.Note)
      .map((note: any) => {
        const complainantReadFlag = note['DC Complainant Read Flg'] || '';
        const respondentReadFlag = note['DC Respondent Read Flg'] || '';
        const readFlag = this.isComplainantUserType ? complainantReadFlag : respondentReadFlag;
        return {
          id: note['Id'] || '',
          author: note['DC Creator Name Calc'] || 'Unknown',
          timestamp: note['Created'],
          body: note['Note'],
          readFlag,
          complainantReadFlag,
          respondentReadFlag
        };
      });
  }

  private buildSystemDocuments(folder?: FolderResponse): Array<{ doc: DocumentItem; folder: FolderResponse }> {
    if (!folder || !Array.isArray(folder.documents)) {
      return [];
    }

    const allowedTypes = new Set(
      (folder.allowedDocumentTypes ?? []).map((d) => (d.nameEn || '').toLowerCase())
    );

    const systemDocs = folder.documents.filter((doc) => {
      const uploadedBy = (doc.uploadedBy || '').toLowerCase();
      const docType = (doc.documentType || '').toLowerCase();
      return uploadedBy === 'system' && !allowedTypes.has(docType);
    });

    const uniqueDocs = new Map<string, DocumentItem>();
    systemDocs.forEach((doc) => {
      const key = doc.documentId || `${doc.documentType}::${doc.label}`;
      if (!uniqueDocs.has(key)) {
        uniqueDocs.set(key, doc);
      }
    });

    return Array.from(uniqueDocs.values()).map((doc) => ({
      doc,
      folder: {
        ...folder,
        documents: [doc]
      }
    }));
  }

  get hasUnreadMessages(): boolean {
    return this.messageHistory.some((m) => (m.readFlag || '').toUpperCase() !== 'Y');
  }

  get visibleMessages(): MessageEntry[] {
    if (this.showAllMessages) {
      return this.messageHistory;
    }
    return this.messageHistory.slice(0, 1);
  }

  get isGuestView() {
    return this.pageView == 'guest' ? true : false;
  }

  // This method is used to expand messages and mark unread messages as read
  expandMessages(): void {
    if (this.showAllMessages || this.messageHistory.length < 1 || this.markingAsRead) {
      this.showAllMessages = true;
      return;
    }
    this.showAllMessages = true;
    this.markUnreadNotesAsRead();
  }

  goBack(): void {
    if (history.length > 1) {
      history.back();
      return;
    }
    window.location.href = '/';
  }

  // This method is used to submit notes/message
  submitResponse(): void {
    this.responseSubmitted = false;
    this.responseForm.markAllAsTouched();

    if (this.responseForm.invalid || this.noteSubmitting) {
      return;
    }

    this.noteSubmitting = true;
    this.caseService
      .submitCaseNote(this.getRequestSerialNumber(), this.responseForm.value.response, {
        noteId: Utils.generateUniqueId(),
        referenceNumber: this.getRequestReferenceNumber(),
        loginName: this.loginName,
        dcEncryptedValue: this.isEncryptedQuery ? "Y" : "",
        isComplainantUser: this.isComplainantUserType
      })
      .subscribe({
        next: () => {
          this.responseSubmitted = true;
          this.noteSubmitting = false;
          this.responseForm.get('response')?.setValue('');
          this.fetchCaseDetail();
        },
        error: () => {
          this.noteSubmitting = false;
          // this.sharedService.toastMessage('ERROR', 'SOMETHING_WENT_WRONG', 'error');
        },
      });
  }

  private getRequestSerialNumber(): string {
    return this.caseNumber;
  }

  private getRequestReferenceNumber(): string {
    return this.referenceNumber;
  }

  private isUrlEncoded(value?: string): boolean {
    if (!value) {
      return false;
    }
    try {
      return decodeURIComponent(value) !== value;
    } catch {
      return false;
    }
  }

  private markUnreadNotesAsRead(): void {
    if (this.markingAsRead) {
      return;
    }
    const unreadNotes = this.messageHistory.filter(
      (m) => m.id && (m.readFlag || '').toUpperCase() !== 'Y'
    );
    const unreadIds = unreadNotes.map((m) => m.id as string);

    if (!unreadIds.length) {
      return;
    }

    this.markingAsRead = true;
    const isComplainantUser = this.isComplainantUserType;
    const noteUpdates = unreadNotes.map((note) => ({
      id: note.id as string,
      complainantReadFlag: isComplainantUser ? 'Y' : (note.complainantReadFlag || ''),
      respondentReadFlag: isComplainantUser ? (note.respondentReadFlag || '') : 'Y'
    }));
    this.caseService
      .updateNotesReadFlag(this.getRequestSerialNumber(), noteUpdates, {
        referenceNumber: this.getRequestReferenceNumber(),
        loginName: this.loginName,
        dcEncryptedValue: this.isEncryptedQuery ? "Y" : ""
      })
      .subscribe({
        next: () => {
          this.messageHistory = this.messageHistory.map((m) => {
            if (!unreadIds.includes(m.id || '')) {
              return m;
            }
            const updatedComplainantReadFlag = isComplainantUser ? 'Y' : (m.complainantReadFlag || '');
            const updatedRespondentReadFlag = isComplainantUser ? (m.respondentReadFlag || '') : 'Y';
            return {
              ...m,
              complainantReadFlag: updatedComplainantReadFlag,
              respondentReadFlag: updatedRespondentReadFlag,
              readFlag: isComplainantUser ? updatedComplainantReadFlag : updatedRespondentReadFlag
            };
          });
          this.markingAsRead = false;
        },
        error: () => {
          this.markingAsRead = false;
          this.sharedService.toastMessage('ERROR', 'SOMETHING_WENT_WRONG', 'error');
        },
      });
  }
  // Changes for the documents type dropdown and file component integration
  get selectedDocumentConfig(): any | null {
    const allowed = this.srFolder?.allowedDocumentTypes ?? [];
    if (!allowed.length) {
      return null;
    }
    if (!this.selectedDocumentType) {
      this.selectedDocumentType = allowed[0].nameEn;
      this.responseForm.get('documentType')?.setValue(this.selectedDocumentType);
      return allowed[0];
    }
    return allowed.find((dt: any) => dt.nameEn === this.selectedDocumentType) ?? allowed[0];
  }

  hasUploadedDocumentsForType(documentType: string): boolean {
    if (!this.srFolder?.documents?.length) {
      return false;
    }
    return this.srFolder.documents.some(
      (doc: any) =>
        (doc.documentType || '').toLowerCase() === (documentType || '').toLowerCase()
    );
  }
  onDocumentTypeSelection(option: any) {
    if (option && option.selectedLov) {
      this.selectedDocumentType = option.selectedLov?.value;
    } else {
      this.selectedDocumentType = '';
    }
  }
}
